module.exports = __webpack_public_path__ + "static/media/w (32).dda1e32b.jpg";